import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/** Benannte Abstände/Maße aus `styles.css` (`--spacing-*`: p-, m-, gap-, w-, h-, size-…). */
export const THEME_SPACING = [
  'rail',
  'rail-button',
  'sidebar-expanded',
  'icon-circle',
  'capsule',
  'card-pad',
  'card-gap',
  'space-1',
  'space-2',
  'space-3',
  'space-4',
  'space-5',
  'space-6',
  'space-8',
  'control-h',
  'button-h',
  'pill-h',
  'signal-size',
  'eye-size',
  'record-icon',
  'settings-nav-w',
  'panel-w',
  // Story 24.1: Kanalliste des Team-Chats.
  'chat-side',
  'head-chart-w',
  'head-chart-h',
  'signal-glyph',
  'button-pad-x',
  'bulk-pad-start',
  'check-size',
  'icon-md',
  'segment-pad',
  'track-pad',
  'track-gap',
  'edge-fade',
  'tile-y',
  'head-min',
  'confirm-min',
  'badge-inset',
  'dot-inset',
  'dot-top',
  'sheet-max',
  'sheet-w',
  'timeline-x',
  'switch-h',
  'switch-off',
  'switch-on',
  'switch-thumb',
  'switch-w',
  'tile-gap',
  // Ticket 1.272: Maß-Tokens der Aufträge (Commit „alle 70 Bereichsdateien auf Tokens“).
  'formula-min',
  'picker-max-h',
  'picker-w',
  'popover-w',
  'preview-min-h',
  'line-remove',
  'field-icon',
  'line-gap',
  'progress-toast-w',
  'record-mark',
  'row-tall',
  'scan-location-w',
  'search-inset',
  // Ticket 1.273: Maß-Tokens der Artikelseiten (Bereich Artikel streng).
  'record-image',
  'image-sheet-w',
  'info-pop-w',
  'media-pop-w',
  'editor-pop-w',
  'editor-min-h',
  'suggest-max-h',
  'property-pop-w',
  'taxonomy-pop-w',
  'taxonomy-max-h',
  'field-name-min',
  // Ticket 1.275: Umsatzverlauf der Startseite (Bereich Startseite streng).
  'trend-h',
  'trend-bar',
  'trend-mark',
  'trend-bar-gap',
  'trend-bar-gap-wide',
] as const;

/** Benannte Höchstbreiten aus `styles.css` (`--container-*`: max-w-…). */
export const THEME_CONTAINERS = [
  'readable',
  // Story 24.1: Lesebreite des Team-Chats.
  'chat-read',
  'field-xs',
  'field-s',
  'field-m',
  'field-l',
  'tip',
  'kpi-tile',
  'chip',
  'login-card',
] as const;

/**
 * Benannte Schriftgrößen aus `styles.css` (`@theme { --text-* }`, Tickets 1.241/1.242/1.243). tailwind-merge kennt sie sonst
 * nicht und hielte `text-row` für eine Farbe – `cn('text-row text-ink')` verlöre dann die Größe. Vitest
 * (`test/cn-tokens.test.ts`) prüft, dass die Listen zu styles.css passen.
 */
export const THEME_TEXT_SIZES = [
  'micro',
  '2xs',
  'pill',
  'caption',
  'sm-plus',
  'body',
  'md',
  'lead',
  'gauge',
  'card-title',
  'tile-title',
  'page-title',
  'record-name',
  'kpi',
  'kpi-sm',
  'display',
  'scan-line',
  'scan-order',
  'field-phone',
  'row',
  'sheet-title',
  'watermark-sm',
  'watermark',
  'hero-sm',
  'hero',
] as const;

/**
 * tailwind-merge mit den Token-Namen: so ersetzt eine spätere Klasse (`px-3`) eine benannte (`px-button-pad-x`) wie
 * früher die Klammer-Werte (`px-[22px]`), statt dass beide stehen bleiben und die CSS-Reihenfolge entscheidet.
 */
const twMerge = extendTailwindMerge({
  extend: { theme: { text: [...THEME_TEXT_SIZES], spacing: [...THEME_SPACING], container: [...THEME_CONTAINERS] } },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
